import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchasingService } from '../../services/purchasing.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { Location } from '@angular/common'
import * as _ from 'underscore';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-open-purchase-orders',
	templateUrl: './open-purchase-orders.component.html',
	styleUrls: ['./open-purchase-orders.component.scss']
})
export class OpenPurchaseOrdersComponent implements OnInit {

	@Input() config: any = [];
	@Input() item: any = false;
	@Input() vendor: any = false;
	@Output() update_item = new EventEmitter < any > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() po_data = new EventEmitter < any > ();
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	purchaseorders: any = [];
	allpurchaseorders: any = [];
	headercolumns: string[] = [
		'actions',
		'orderno',
		'status_id',
		'suppname',
		'comments',
		'orddate',
		'requisitionno',
		'ordervalue',
		'orderpendingvalue',
		'ordereditems',
		'deliverydate',
		'initiator',

	];

	statuses: any = [];
	openOrderData: any = [];
	baselink = '';
	explink = '';
	reclink = '';
	color = '';
	podetails: any = [];
	vendorSearch = new FormControl('');
	searchInputItems = new UntypedFormControl('');
	status = new FormControl('');
	searchBySize = false;
	includeSizes = false;
	searching = false
	search: any = false;
	itemsearch = false;
	itemsearchsubscription: any = false;
	itemsearchresults: any = [];
	purchaseordersFiltered: any = [];
	tableData: any = [];

	constructor(private printService:PrintService, private route: ActivatedRoute, private purchasingService: PurchasingService, private globalsService: GlobalsService, public globalSearchService: GlobalSearchService, public location: Location, private modalService: NgbModal) {
		this.color = this.globalSearchService.getColor();
		this.config = this.globalsService.getApiConfig()
	}

	ngOnInit(): void {
		this.baselink = this.config.apiServer.poLink;
		this.explink = '?route=apir/documents/popicking/excel&key=' + this.config.apiCredentials.clientId + '&orderno=';
		this.reclink = this.config.apiServer.recLink;
	}

	loadData() {
		this.purchasingService.searchPurchaseOrders(this.search).subscribe((results: any) => {
			this.allpurchaseorders = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.openOrderData = results.pos;
			this.setTableData(results.pos)
		});
	}

	getStatus(id: any) {
		return this.statuses.filter((st) => {
			return parseFloat(st.status_id) == parseFloat(id)
		})[0];
	}

	loadOrder(orderno: any) {
		this.purchasingService.loadPurchaseOrder(orderno).subscribe((result: any) => {
			this.orderloaded.emit(result);
		});
	}

	searchItems() {
		const value = this.searchInputItems.value;

		const search = {
			status: this.status.value,
			keywords: this.searchInputItems.value,
			item: this.item,
			vendor: this.vendor,
			size: this.searchBySize
		}

		this.purchasingService.searchPurchaseOrders(search).subscribe((results: any) => {

			this.allpurchaseorders = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.openOrderData = results.pos;
			this.setTableData(results.pos)
		});
	}

	searchOrders() {
		const search = {
			status: this.status.value,
			keywords: this.vendorSearch.value,
			item: this.item,
			vendor: this.vendor
		}

		this.purchasingService.searchPurchaseOrders(search).subscribe((results: any) => {
			this.allpurchaseorders = results;
			this.po_data.emit(results);
			this.statuses = results.statuses
			this.openOrderData = results.pos;
			this.onInput()
		});
	}

	updateStatus(event: any, trans: any) {
		const status_details = this.getStatus(event.value);
		const index = this.allpurchaseorders.pos.indexOf(trans)
		this.allpurchaseorders.pos[index].editing = false;
		this.allpurchaseorders.pos[index].status_id = status_details.status_id;
		this.allpurchaseorders.pos[index].statusname = status_details.name;

		this.purchasingService.updateStatus(this.allpurchaseorders.pos[index]).subscribe((result: any) => {
			this.searchOrders();

		})

	}

	exportExcel() {
		this.globalSearchService.exportJsonToExcel(this.allpurchaseorders.pos, 'OpenPurchaseOrders');
	}



	toggleStatusChange(trans: any) {
		const index = this.allpurchaseorders.pos.indexOf(trans);
		if (this.allpurchaseorders.pos[index].editing) {
			this.allpurchaseorders.pos[index].editing = false;
		} else {
			this.allpurchaseorders.pos[index].editing = true;
		}
	}

	onInput() {
		//tood make this ajax call to search for items on orders as well
		this.purchaseorders = this.openOrderData
		const search = this.vendorSearch.value;
		this.searching = true;
		this.filterByStatus();
		this.purchaseorders = this.globalSearchService.filterItem(this.purchaseorders, search, 'orderno,suppname,supplierno,deliverydate,itemcode,itemdescription,requisitionno,initiator,comments');
		this.setTableData(this.purchaseorders)
		this.searching = false;
	}

	announceSortChange(event: any) {

	}

	viewOrder(orderno: any, content: any) {
		this.purchasingService.getPurchaseOrder(orderno).subscribe((order: any) => {
			this.podetails = order
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
		});
	}


	back(): void {
		this.location.back()
	}

	setTableData(data: any) {
		if(!this.tableData.length){
			this.tableData = data;
		}
		this.purchaseorders = new MatTableDataSource(data);
		this.purchaseorders.sort = this.sort;
		this.purchaseorders.paginator = this.paginator;
		this.filterByStatus();
	}

	ngOnChanges(changes: any) {
		if (changes) {

			if(this.config.env.package == 'tires'){
				this.includeSizes = true;
			}

			const search = {
				item: this.item,
				vendor: this.vendor,
				size: this.includeSizes
			}

			this.purchasingService.searchPurchaseOrders(search).subscribe((results: any) => {
				this.allpurchaseorders = results;
				this.po_data.emit(results);
				this.statuses = results.statuses
				this.openOrderData = results.pos;
				this.setTableData(results.pos)
			});
		}
	}

	//conflicting status searches todo: correct
	filterByStatus() {
		const key = this.status.value

		if (!key) {
			//this.purchaseorders = this.openOrderData
		} else {
			this.purchaseorders = this.openOrderData.filter((item: any) => { return item.status_id == key })
		}
	}

	getTotalQuantity(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + parseFloat(item.quantityord), 0);
	}

	getTotalValue(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + (parseFloat(item.unitprice) * parseFloat(item.quantityord)), 0);
	}

	async copyToClipboard(text: string): Promise < void > {
		try {
			await navigator.clipboard.writeText(text);
		} catch (err) {}
	}


	onStatusSelection() {
		this.onInput()
	}

	exportXls() {
		const date = new Date();
		const today = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
		const encoded: string = this.globalSearchService.base64encode(this.getHtmlTable());
		const data = {
			content: encoded,
			filename: 'openPurchaseOrders',
			title: 'Open Purchase Orders',
			subtitle: `All open purchase orders as of ${today}`
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	exportPdf() {
		const date = new Date();
		const today = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
		const encoded: string = this.globalSearchService.base64encode(this.getHtmlTable());
		const data = {
			content: encoded,
			filename: 'openPurchaseOrders',
			title: 'Open Purchase Orders',
			subtitle: `All open purchase orders as of ${today}`
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	getHtmlTable() {
		const style = {
			'1': 'style="text-align:left"',
			'2': 'style="text-align:center"',
			'3': 'style="text-align:right"',
		}

		const printjson = [];
		(this.allpurchaseorders.pos).forEach(o => {
			const row = {
				'1Order #': o.orderno,
				'2Requisition #': o.requisitionno,
				'1Status': o.statusname,
				'1Order Date': o.orddate,
				'1Wanted Date': o.deliverydate,
				'1Supplier #': o.supplierno,
				'1Supplier': o.suppname,
				'2#Ordered': o.ordered,
				'2#Recieved': o.rec,
				'2#Pending': o.pendingitems,
				'3Order Value': this.financial(Number(o.ordervalue)),
				'3Pending Value': this.financial(Number(o.orderpendingvalue)),
				'3Initiator': o.initiator,
			}
			printjson.push(row);
		});

		let html = '<table><thead><tr>';
		Object.keys(printjson[0]).forEach((k) => {
			html += `<th>${k.substring(1)}</th>`;
		})

		html += '</tr></thead><tbody>';
		printjson.forEach(row => {
			html += '<tr>'
			Object.keys(row).forEach((k) => {
				html += `<td ${style[k.substring(0,1)]}>${row[k]}</td>`
			})
			html += '</tr>'
		});
		html += '</tbody></table>'
		return html;
	}

	getLineTotal(item: any): number {
		const price = parseFloat(item.unitprice ?? '0') || 0;
		const qty = parseFloat(item.quantityord ?? '0') || 0;
		const fet = (this.config.env.package === 'tires') ? (parseFloat(item.fetcharge ?? '0') || 0) : 0;
		return this.financial((price + fet) * qty);
	}

	getTotalFet(): number {
		const total = this.podetails.polines.reduce((sum, item) => {
			const fet = parseFloat(item.fetcharge ?? '0') || 0;
			const qty = parseFloat(item.quantityord ?? '0') || 0;
			return sum + fet * qty;
		}, 0);
		return this.financial(total);
	}

	getTotalValueWithFet(): number {
		const total = this.podetails.polines.reduce((sum, item) => {
			const price = parseFloat(item.unitprice ?? '0') || 0;
			const qty = parseFloat(item.quantityord ?? '0') || 0;
			const fet = (this.config.env.package === 'tires') ? (parseFloat(item.fetcharge ?? '0') || 0) : 0;

			// Optional: Debug log
			if (qty > 100) {
				console.warn('Unusual quantity detected:', { item, price, qty, fet });
			}

			return sum + (price + fet) * qty;
		}, 0);
		return this.financial(total);
	}

	financial(num: number): number {
		if (!num) {
			num = 0.00;
		}
		const rounded = Math.round((num + Number.EPSILON) * 100) / 100;
		return parseFloat(rounded.toFixed(2));
	}


	searchSize(){
		const search = this.searchInputItems.value;
		const ordersFiltered  = this.tableData.filter((ord) => {
			return ord.sizes.includes(search); 
		});
		this.setTableData(ordersFiltered);
	}

	switchToSize(){
		this.searchBySize = !this.searchBySize;
	}
}
